import { Selector } from './types/selector.type';
import { isDev } from './utils/is-dev.fn';

export class ComponentRegistry {
  private static registry = new Map<CustomElementConstructor, Selector<any>>();
  private static components: CustomElementConstructor[] = [];
  private static stylesRegistry = new Map<CustomElementConstructor, string>();

  static declare(component: CustomElementConstructor) {
    this.components.push(component);
  }

  static registerStyles(styles: string, component: CustomElementConstructor) {
    this.stylesRegistry.set(component, styles);
  }

  static getStylesheet(component: CustomElementConstructor) {
    const stylesheet = this.stylesRegistry.get(component);

    if (stylesheet === undefined) {
      return undefined;
    }

    const style = document.createElement('style');

    style.innerHTML = stylesheet;

    return style;
  }

  static register<T extends string>(
    selector: Selector<T>,
    component: CustomElementConstructor
  ) {
    this.registry.set(component, selector);
  }

  static bootstrap() {
    for (const [component, selector] of this.registry.entries()) {
      window.customElements.define(selector, component);
    }
  }
}
